import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { PublicShowcase } from './Showcase'
import './styles.css'

const publicShowcase =
  window.location.hostname === 'apps.sasid.ai' ||
  window.location.pathname === '/showcase' ||
  window.location.pathname.startsWith('/showcase/')

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {publicShowcase ? <PublicShowcase /> : <App />}
  </StrictMode>,
)

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => undefined)
  })
}
